/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { useDispatch } from 'react-redux';

import SessionTimeoutDialog from './SessionTimeoutDialog';
import useIdleTimeout from './useIdleTimeout';
import useVisibilityChange from 'common/hooks/useVisibilityChange';
import { AuthenticationActions } from 'common/modules/auth';

import Time from 'common/constants/time';

type Props = {
    /* time_in_msec */
    timeout: number
};

const MODAL_DISPLAY_TIME = 60 * Time.sec;

const SessionIdleTimeout = ({ timeout }: Props): React.Node => {
    const [showDialog, setShowDialog] = React.useState(false);
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(
            AuthenticationActions.logoutFromLocation({
                currentLocation: location
            })
        );
    };

    const onActivity = () => setShowDialog(false);

    const timer = useIdleTimeout({
        onIdle: timeElapsed => {
            // timeElapsed is more than threshold directly logout
            // cases when user closes the tab or leave the tab open
            if (timeElapsed > 60 * Time.sec) {
                handleLogout();
            } else {
                setShowDialog(true);
            }
        },
        onActivity,
        timeout: timeout - MODAL_DISPLAY_TIME
    });

    useVisibilityChange(isVisible => {
        // When user is idle on first tab until onIdle action is triggered(Show Modal)
        // and user performs actions on the second tab and returns to first tab,
        // Trigger onActive action (close the onIdle Modal)
        isVisible && checkAndLogout();
    });

    const checkAndLogout = () => {
        // When user is idle on first tab until onIdle action is triggered(Show Modal)
        // and user performs actions on the second tab, prevent logout in second tab
        timer.checkIfIdle() ? handleLogout() : onActivity();
    };

    return (
        showDialog && (
            <SessionTimeoutDialog
                delay={MODAL_DISPLAY_TIME}
                onTimeout={checkAndLogout}
            />
        )
    );
};

export default SessionIdleTimeout;
